const recogeDatos = () => {
    
   


    
      const nombre = document.querySelector("#nombre-receptor").value;
     
    
      const bienvenida = document.querySelector("#resultadoPases");
      let mensaje;
      let mensajePases;
      
    
      
          if (nombre.toLowerCase() === "francisco garcia") {
           mensajePases = ", tienes un pase doble, saludos";
          }
    
          else if (nombre.toLowerCase() === "reina isabel") {
            mensajePases = ", tiene usted un un pase familiar, saludos";
           }
    
          else if (nombre.toLowerCase() === "camila parker") {
            mensajePases = ", tiene un pase doble, saludos";
           }
           else if (nombre.toLowerCase() === "principe andres") {
            mensajePases = ", tiene un pase doble, saludos";
           }
           else if (nombre.toLowerCase() === "sarah ferguson") {
            mensajePases = ", tiene un pase individual, saludos";
           }
           else if (nombre.toLowerCase() === "megan markle") {
            mensajePases = ", a usted ni la invitaron";
           }
    
          else {
            mensajePases = ", lo sentimos no está usted en la lista.";
          }
    
     
      mensaje = "Hola, " + nombre + mensajePases;
    
      bienvenida.innerHTML = mensaje;
    
    };

    var miForm = document.querySelector("#formulario");

miForm.addEventListener("submit", recogeDatos);

    export default recogeDatos;
    